import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: React.ReactNode;
}
const FeaturePoint21 = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-1224">
      <div className="flex-shrink-0 mt-1" data-id="element-1225">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-1226" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-1227">{children}</div>
    </div>;
};
export default FeaturePoint21;